export default {
  namespaced: true,
  state: {
    declarationAgreementAccepted: false,
  },
  getters: {
    declarationAgreementAccepted: state => state.declarationAgreementAccepted
  },
  actions: {
    resetCurrentDeclaration: (context) => {
      context.commit('resetCurrentDeclaration');
    },
    setDeclarationAgreementAccepted: (context, declarationAgreementAccepted,) => {
      context.commit("setDeclarationAgreementAccepted", declarationAgreementAccepted);
    },
  },
  mutations: {
    resetCurrentDeclaration: (state) => {
      state.declarationAgreementAccepted = false;
    },
    setDeclarationAgreementAccepted: (state, declarationAgreementAccepted) => {
      state.declarationAgreementAccepted = declarationAgreementAccepted;
    }
  }
}
